export default __webpack_public_path__ + "static/logo-13-a30347a62e0173bd135b5986efbff1ae.png";